export default __webpack_public_path__ + "static/media/collapse_arrow_down_icon.7a6d128a.svg";